import FormValidator from './FormValidator.js';
// spinner
import spinner from './spinner.js';
import { ajaxURL} from './variables.js';
import swal from 'sweetalert2';

window.addEventListener('DOMContentLoaded', () => {


    let userForms = document.querySelectorAll('.da__form-user');

    userForms.forEach(form => {
       
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            let messageDiv = form.closest('.da__form-wrapper').querySelector('.da__form-message');
            // clear the message div
            messageDiv.innerHTML = '';
            const validateForm = new FormValidator(form);

          
            // check if the form is valid
            if (validateForm.validate()) {
                    // get message div
                    // append the spinner to the form
                    let spinnerDiv = document.createElement('div');
                    spinnerDiv.classList.add('da__spinner');
                    spinnerDiv.innerHTML = spinner;
                    form.appendChild(spinnerDiv);
                    // if the form is valid, we send the data to the server
                    // we create a new FormData object and append the form data to it
                    let data = new FormData(form);
                    data.append('action', 'update_user_profile');
                    // we send the data to the server
                    fetch(ajaxURL, {
                        method: 'POST',
                        body: data
                    })
                    .then(response => response.json())
                    .then(data => {
                        console.log(data);

                        // remove the spinner from the form
                        spinnerDiv.remove();
                        if (data.success) {
                            // if the server responds with success, we reload the page
                            // redirect to the login redirect page
                            // window.location.href = loginRedirect;
                            // messageDiv.innerHTML = data.message;
                            swal.fire({
                                title: 'Success',
                                text: data.message,
                                icon: 'success',
                                showCancelButton: false,
                                showConfirmButton: false,
                                timer: 2000
                            }).then(() => {
                                location.reload();
                            });
                            
                            
                        }else{
                            // if the server responds with an error, we log it
                            console.error(data.error);
                            // show the error message
                            messageDiv.innerHTML = data.message;
                        }
                    });

                    
                
            }else{
                // if the form is not valid, we log an error
                console.log('Form is not valid');
            }

       
        });



    });



}); // end of DOMContentLoaded



